import {
  BrandAndMarketListItem,
  CodeAndLabel,
  DateTimeRestrictionData,
  FormDataRouteRestriction,
  RuleFormDataAgencyOrGroup,
  SearchTravelRange,
  GuidIdCodeAndLabel,
} from '../../../integrated-client/models';

export interface ITicketTLOV2EditorData {
  id?: string | null;
  disabled?: boolean;
  relevance?: number;
  effectiveDateFrom?: any; // TODO
  effectiveDateTo?: any; // TODO
  dateTimeRestrictions?: Array<DateTimeRestrictionData> | null;
  dateTimeRestrictionsTimeZone?: CodeAndLabel;
  brandAndMarket?: BrandAndMarketListItem;
  distributionChannels?: Array<number> | null;
  agenciesAndGroups?: Array<RuleFormDataAgencyOrGroup> | null;
  routes?: Array<FormDataRouteRestriction> | null;
  salesJourneys?: Array<string> | null;
  accountCodes?: string[] | null | undefined;
  excludeAccountCodes?: boolean | undefined;
  bookingClasses?: string[] | null | undefined;
  excludeBookingClasses?: boolean | undefined;
  marketingCarriers?: GuidIdCodeAndLabel[] | null | undefined;
  cabinClasses?: CodeAndLabel[] | null;
  travelDates?: Array<SearchTravelRange> | null;
  providers?: string[] | null;
  fareTypes?: CodeAndLabel[] | null;
  dayOffset?: number | null;
  time?: any; //TODO
  overrideDays?: number | null;
  offsetDays?: number | null;

  cloneSourceId?: string | null;
  allowEdit?: boolean;
}

export interface IEditorData {
  ticketTLOV2EditorData: ITicketTLOV2EditorData;
  validation?: any;
}

export class TicketTLOV2EditorData implements ITicketTLOV2EditorData {
  id?: string | null;
  disabled?: boolean;
  relevance?: number;
  effectiveDateFrom?: any; // TODO
  effectiveDateTo?: any; // TODO
  dateTimeRestrictions?: Array<DateTimeRestrictionData> | null;
  dateTimeRestrictionsTimeZone?: CodeAndLabel;
  brandAndMarket?: BrandAndMarketListItem;
  distributionChannels?: Array<number> | null;
  agenciesAndGroups?: Array<RuleFormDataAgencyOrGroup> | null;
  routes?: Array<FormDataRouteRestriction> | null;
  salesJourneys?: Array<string> | null;
  accountCodes?: string[] | null | undefined;
  excludeAccountCodes?: boolean | undefined;
  bookingClasses?: string[] | null | undefined;
  excludeBookingClasses?: boolean | undefined;
  marketingCarriers?: GuidIdCodeAndLabel[] | null | undefined;
  cabinClasses?: CodeAndLabel[] | null | undefined;
  travelDates?: Array<SearchTravelRange> | null | undefined;
  providers?: string[] | null | undefined;
  fareTypes?: CodeAndLabel[] | null | undefined;
  dayOffset?: number | null;
  time?: any; //TODO
  offsetDays?: number | null;
  overrideDays?: number | null;

  cloneSourceId?: string | null;
  allowEdit?: boolean;

  constructor() {
    this.disabled = false;
  }
}

export class EditorData implements IEditorData {
  ticketTLOV2EditorData: ITicketTLOV2EditorData;
  validation?: any;

  constructor() {
    this.ticketTLOV2EditorData = new TicketTLOV2EditorData();
  }
}
